export default "__VITE_ASSET__2c5f233f__"